<template>
    <div class="best-products">
        <section-title :title="'Лучшие товары'" :section_link="'best-products'"></section-title>
        <div class="best-products-cards">
            <div class="card" v-for="card in cardsToShow" >
                <best-product-card :card="card"></best-product-card>
            </div>
        </div>
    </div>
</template>

<script>
    import BestProductCard from '../Cards/BestProductCard';
    import SectionTitle from '../Helpers/SectionTitle';

    export default {
        name: "BestProdSection",
        components: { BestProductCard, SectionTitle },
        props: {
            showAount: {
                type: Number,
                default: 8
            }
        },
        data() {
            return {
                cards: [
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: 'new'
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '550',
                        amount: '896',
                        status: 'sale'
                    },
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: 'new'
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '600',
                        amount: '896',
                        status: 'sale'
                    },
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '89',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'IPhone 11',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '342',
                        amount: '896',
                        status: ''
                    },
                    {
                        title: 'Xiaomi Mi Notebook Pro 2019',
                        price: {
                            prev: '35 543',
                            curr: '35 543'
                        },
                        sold: '390',
                        amount: '896',
                        status: ''
                    },
                ]
            }
        },
        computed: {
            cardsToShow() {
                return this.cards.slice(0, this.showAount)
            }
        }
    };
</script>

<style scoped lang="scss">
    .best-products {
        &-cards {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }
    }
</style>
